export type VideoReferenceAvailabilityGuardState =
  | "pending"
  | "allow"
  | "unavailable"
  | "error";

export type VideoReferenceAvailability = { enabled: boolean };

export function parseVideoReferenceAvailability(
  value: unknown,
): VideoReferenceAvailability {
  if (
    !value ||
    typeof value !== "object" ||
    typeof (value as { enabled?: unknown }).enabled !== "boolean"
  ) {
    throw new Error("The availability service returned an invalid response.");
  }
  return { enabled: (value as { enabled: boolean }).enabled };
}

// Cached availability is deliberately not enough to mount the tool. A fresh
// post-mount response is required before an older cached value can mount it.
// Later background refetches must not hold the entire route in a loading loop.
export function videoReferenceAvailabilityGuardState(input: {
  brandId?: string;
  authLoading: boolean;
  isMaster: boolean;
  statusLoading: boolean;
  statusFetching: boolean;
  statusFetchedAfterMount: boolean;
  statusError: boolean;
  enabled?: boolean;
}): VideoReferenceAvailabilityGuardState {
  if (
    input.authLoading ||
    input.statusLoading ||
    (input.statusFetching && !input.statusFetchedAfterMount)
  ) return "pending";
  if (!input.isMaster) return "unavailable";
  if (!input.brandId || input.statusError) return "error";
  if (!input.enabled) return "unavailable";
  return "allow";
}
